import type { RoundName } from "../domain/round/types";

const TOURNAMENT_KEY = "golf-scoring-v2.round-tournament";
const ROUND_KEY = "golf-scoring-v2.round-name";
const SEASON_KEY = "golf-scoring-v2.round-season";
const ROUNDS: RoundName[] = ["R1", "R2", "R3", "R4"];

function query() {
  return typeof window === "undefined" ? new URLSearchParams() : new URLSearchParams(window.location.search);
}

export function initialTournamentId() {
  return query().get("tournament") || (typeof window !== "undefined" ? window.localStorage.getItem(TOURNAMENT_KEY) || "" : "");
}

export function initialRoundName(): RoundName {
  const value = (query().get("round") || (typeof window !== "undefined" ? window.localStorage.getItem(ROUND_KEY) || "" : "")).toUpperCase();
  return ROUNDS.includes(value as RoundName) ? value as RoundName : "R1";
}

export function initialSeason() {
  const fromQuery = Number(query().get("season") || 0);
  const fromStorage = typeof window !== "undefined" ? Number(window.localStorage.getItem(SEASON_KEY) || 0) : 0;
  const value = fromQuery || fromStorage || 2026;
  return value >= 2000 && value <= 2200 ? value : 2026;
}

export function persistRoundSelection(tournamentId: string, round: RoundName, season = 2026) {
  if (typeof window === "undefined") return;
  if (tournamentId) window.localStorage.setItem(TOURNAMENT_KEY, tournamentId);
  window.localStorage.setItem(ROUND_KEY, round);
  window.localStorage.setItem(SEASON_KEY, String(season));

  const params = new URLSearchParams(window.location.search);
  if (tournamentId) params.set("tournament", tournamentId);
  params.set("round", round);
  params.set("season", String(season));
  const next = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
  window.history.replaceState(window.history.state, "", next);
}

export function roundWorkspaceSearch() {
  if (typeof window === "undefined") return "";
  const params = new URLSearchParams();
  const tournament = window.localStorage.getItem(TOURNAMENT_KEY) || query().get("tournament") || "";
  const round = (window.localStorage.getItem(ROUND_KEY) || query().get("round") || "R1").toUpperCase();
  const season = window.localStorage.getItem(SEASON_KEY) || query().get("season") || "2026";
  if (tournament) params.set("tournament", tournament);
  params.set("round", ROUNDS.includes(round as RoundName) ? round : "R1");
  params.set("season", season);
  return `?${params.toString()}`;
}
